import Vue from "vue";

const modulo_ordenes = {
    strict: false,

    state: {
        ordenes: [],
        metodos_pago: [],
        current: 0,
        page: 1,

        // state que se usa para almacenar las ordenes seleccionadas para crear una factura desde "facturacion"
        ordenesData: []
    },

    getters: {
        getordenes: (state) => state.ordenes,
        getOrdenesData: (state) => state.ordenesData,
    },

    mutations: {
        get_ordenes: (state, ordenes) => {
            state.ordenes = ordenes;
            state.page = 2;
        },
        update_ordenes: (state, ordenes) => {
            state.ordenes = state.ordenes.concat(ordenes.data);
            state.page = ordenes.current_page + 1;
        },
        add_search: (state, ordenes) => {
            state.ordenes = state.ordenes.concat(ordenes);
        },

        // mutaciones del estado ordenesData
        setOrdenesData(state, data) {
            state.ordenesData = data;
        },
        clearOrdenesData(state) {
            state.ordenesData = [];
        }
    },

    actions: {
        getOrdenes: (context, vm) => {
            axios.get("api/get-ordenes?amount=15&page=1").then(
                (res) => {
                    context.commit("get_ordenes", res.data.data);
                },
                (res) => {}
            );
        },
        getOrdenesWithId: (context, vm) => {
            axios.get(`api/get-ordenes?amount=15&page=1`).then(
                (res) => {
                    context.commit("get_ordenes", res.data.data);
                },
                (res) => {}
            );
        },
        getOrdenesNext: (context, vm) => {
            axios
                .get(
                    `api/get-ordenes?amount=15&page=${context.state.page ?? 1}`
                )
                .then(
                    (res) => {
                        context.commit("update_ordenes", res.data);
                    },
                    (res) => {}
                );
        },
        searchOrden: (context, vm) => {
            axios
                .get(
                    `api/get-ordenes?amount=15&page=1${
                        vm ? `&busqueda=${vm}` : ""
                    }`
                )
                .then(
                    (res) => {
                        context.commit("update_ordenes", res.data);
                    },
                    (res) => {}
                );
        },

        // Actions para establecer y remover ordenesData
        setOrdenesData({ commit }, data) {
            commit('setOrdenesData', data);
        },
        clearOrdenesData({ commit }) {
            commit('clearOrdenesData');
        }
    },
};

export default modulo_ordenes;
